module.exports = __webpack_public_path__ + "img/2012-08-18 13.06.20.1195d596.jpg";